export default {
    CONTRACT_TEMPLATE: "CONTRACT_TEMPLATE",
    OFFLINE_CONTRACT: "OFFLINE_CONTRACT"
}
